"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const Colors_1 = require("../../../Colors");
const theme_1 = require("../../theme");
const docsColor = Colors_1.Colors.blue[2];
exports.theme = {
    base: 'vs-dark',
    inherit: true,
    rules: [
        { token: '', foreground: docsColor },
        { token: 'identifier.gql', foreground: Colors_1.Colors.grey[0] },
        { token: 'type', foreground: theme_1.GraphQLColors.type },
        { token: 'keyword', foreground: Colors_1.Colors.green[0] },
        { token: 'input', foreground: theme_1.GraphQLColors.input },
        { token: 'interface', foreground: theme_1.GraphQLColors.interface },
        { token: 'enum', foreground: theme_1.GraphQLColors.enum },
        { token: 'extend', foreground: theme_1.GraphQLColors.extend },
        { token: 'input', foreground: theme_1.GraphQLColors.input },
        { token: 'directive', foreground: theme_1.GraphQLColors.directive },
        { token: 'scalar', foreground: theme_1.GraphQLColors.scalar },
        { token: 'union', foreground: theme_1.GraphQLColors.union },
        { token: 'annotation', foreground: Colors_1.Colors.grey[1] },
        { token: 'md', foreground: Colors_1.Colors.blue[3] },
        { token: 'string.md', foreground: docsColor },
        { token: 'string.doc', foreground: docsColor },
        { token: 'string.gql', foreground: Colors_1.mix(Colors_1.Colors.yellow[0], Colors_1.Colors.grey[0]) },
        { token: 'string.quote.gql', foreground: Colors_1.mix(Colors_1.Colors.yellow[0], Colors_1.Colors.grey[0]) },
        { token: 'comment.gql', foreground: Colors_1.Colors.blue[3] },
        { token: 'exclamation', fontStyle: 'bold', foreground: Colors_1.mix(Colors_1.Colors.yellow[0], Colors_1.Colors.grey[0], 90.0) },
    ],
    colors: {
        'editor.foreground': Colors_1.Colors.grey[0],
        'editor.background': `#0b050d`,
        'minimap.background': '#0b050d',
    },
};
